import { memo } from 'react';

type SmartSearchPromotionDropdownProps = {
  onLearnMoreClick: () => void;
};

const SMART_SEARCH_EXAMPLE_SEARCH_PHRASES = [
  'videos of dogs running',
  'cats chasing laser pointers',
  'happy faces wearing colorful hats',
  'children playing in the park',
  'sports action shots',
  'beautiful dance performances',
];

export const SmartSearchPromotionDropdown = memo(({ onLearnMoreClick }: SmartSearchPromotionDropdownProps) => {
  const examplePills = SMART_SEARCH_EXAMPLE_SEARCH_PHRASES.map((pill) => (
    <div className="relative flex items-center justify-center rounded-[100px] bg-gray-1/40 px-4 py-2" key={pill}>
      <div className="pointer-events-none absolute inset-0 rounded-[100px] border border-gray-1 [mask-composite:intersect] [mask-image:radial-gradient(circle_at_100%_0%,transparent_7.5%,white_15%),radial-gradient(circle_at_0%_100%,transparent_7.5%,white_15%)]"></div>
      <div className="justify-center font-semibold text-14 text-purple-10 leading-tight">&ldquo;{pill}&rdquo;</div>
    </div>
  ));

  return (
    <div
      data-theme="light"
      className="relative min-h-0 w-full grow overflow-y-auto"
      data-testid="SMART_SEARCH_PROMOTION_DROPDOWN"
    >
      <div className="inline-flex w-full flex-col items-start justify-start overflow-visible [background:linear-gradient(180deg,#E4DEFC_50%,#FFF_85%,#FFF_100%)]">
        <div className="flex w-full justify-center px-4 pt-3 pb-1">
          <div className="inline-flex max-w-[600px] flex-wrap place-content-center items-center gap-2">
            {examplePills}
          </div>
        </div>
        <div className="flex flex-col items-center justify-center gap-2 self-stretch overflow-visible px-4 pt-1 pb-4">
          <div className="flex w-[340px] flex-col gap-2">
            <div className="flex flex-col items-center justify-center gap-1 self-stretch">
              <div className="inline-flex items-center justify-center self-stretch">
                <div className="justify-center">
                  <span className="inline font-control-upright font-normal text-[19px] text-gray-12 leading-[20px] tracking-tight">
                    Search how you <span className="font-control tracking-[1px]">think.</span>
                  </span>
                </div>
              </div>
              <div className="justify-center self-stretch text-center font-normal text-14 text-gray-12 leading-[20px] tracking-tight">
                Smart search expands your search using AI to find exactly what you&rsquo;re looking for&mdash;like
                magic.
              </div>
              <div className="flex flex-col items-start justify-start rounded">
                <button
                  className="inline-flex items-center justify-center gap-1 rounded bg-gray-1 px-2 py-[3px] text-center font-semibold text-12 text-gray-12 leading-[18px] tracking-tight outline outline-1 outline-gray-5 outline-offset-[-1px] hover:bg-gray-3"
                  onClick={onLearnMoreClick}
                  type="button"
                >
                  Learn more
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

SmartSearchPromotionDropdown.displayName = 'SmartSearchPromotionDropdown';
